(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-bizoo-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.vcInit === '1') return;
      root.dataset.vcInit = '1';
      var track = root.querySelector('[data-vc-track]');
      var url = root.dataset.src;
      var profileUrl = root.dataset.profileUrl || '#';
      var starsSrc = root.dataset.starsSrc || '';
      var logoSrc = root.dataset.logoSrc || '';
      var speed = parseInt(root.dataset.speed, 10) || 60;

      function escape(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }
      function cardHtml(r) {
        return (
          '<a class="vc-bizoo-card" href="' + escape(profileUrl) +
          '" target="_blank" rel="noopener nofollow">' +
          '<div class="vc-bizoo-card__top">' +
            '<img class="vc-bizoo-card__stars" src="' + escape(starsSrc) +
              '" alt="Rating ' + escape(r.rating) + ' din 5" width="106" height="20" loading="lazy">' +
            '<span class="vc-bizoo-card__date">' + escape(r.date || '') + '</span>' +
          '</div>' +
          '<p class="vc-bizoo-card__text">' + escape(r.text || '') + '</p>' +
          '<div class="vc-bizoo-card__foot">' +
            '<span class="vc-bizoo-card__author">' + escape(r.author || '') + '</span>' +
            '<span class="vc-bizoo-card__via">via <img class="vc-bizoo-card__logo" src="' +
              escape(logoSrc) + '" alt="Bizoo" width="60" height="18" loading="lazy"></span>' +
          '</div>' +
          '</a>'
        );
      }

      fetch(url, { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var reviews = (data && data.reviews) || [];
          if (!reviews.length) {
            track.innerHTML = '';
            return;
          }
          var html = reviews.map(cardHtml).join('');
          // Render TWO copies so the second is in viewport while the first scrolls past.
          track.innerHTML = html + html;
          // Measure the EXACT pixel width of one copy (including the gap that follows it),
          // then animate a translateX of that exact distance. -50% percentage rounding can
          // miss by 1-N gap widths on small viewports, producing a visible hiccup.
          requestAnimationFrame(function () {
            var children = track.children;
            var n = reviews.length;
            if (children.length < n) return;
            // unit = sum of first N card widths + N gaps (one trailing gap to seam to next copy)
            var styles = window.getComputedStyle(track);
            var gap = parseFloat(styles.columnGap || styles.gap) || 0;
            var unit = 0;
            for (var i = 0; i < n; i++) {
              unit += children[i].getBoundingClientRect().width + gap;
            }
            var duration = Math.max(20, unit / speed);
            root.style.setProperty('--vc-bizoo-loop', unit.toFixed(2) + 'px');
            root.style.setProperty('--vc-bizoo-duration', duration.toFixed(1) + 's');
          });
        })
        .catch(function () {
          track.innerHTML = '';
        });
    }

    function boot() {
      var nodes = document.querySelectorAll('[data-vc-bizoo-reviews]');
      if (!('IntersectionObserver' in window)) {
        nodes.forEach(init);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            init(e.target);
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '200px' });
      nodes.forEach(function (n) { io.observe(n); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vc-cgallery]').forEach(init);

    async function init(grid) {
      const src = grid.dataset.src;
      let urls = [];
      try {
        const res = await fetch(src, { credentials: 'omit' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        urls = await res.json();
      } catch (err) {
        grid.innerHTML = '<p class="vc-cgallery__loading">Galeria nu poate fi încărcată momentan. (' + err.message + ')</p>';
        grid.removeAttribute('aria-busy');
        return;
      }
      if (!Array.isArray(urls) || urls.length === 0) {
        grid.innerHTML = '<p class="vc-cgallery__loading">Niciun client n-a trimis fotografii încă.</p>';
        grid.removeAttribute('aria-busy');
        return;
      }

      // Build the grid items.
      grid.innerHTML = '';
      urls.forEach(function (url, i) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vc-cgallery__item';
        btn.setAttribute('aria-label', 'Deschide imaginea ' + (i + 1) + ' din ' + urls.length);
        btn.dataset.index = String(i);
        btn.innerHTML =
          '<img class="vc-cgallery__img" src="' + escapeAttr(url) + '" alt="" loading="lazy" decoding="async">' +
          '<span class="vc-cgallery__overlay" aria-hidden="true"><span class="vc-cgallery__overlay-icon">⤢</span></span>';
        btn.addEventListener('click', function () { openModal(i); });
        grid.appendChild(btn);
      });
      grid.removeAttribute('aria-busy');

      // Modal wiring.
      const section = grid.closest('.vc-cgallery');
      const modal = section.querySelector('[data-vc-cgallery-modal]');
      const img = modal.querySelector('.vc-cgallery__modal-img');
      const counter = modal.querySelector('.vc-cgallery__counter');
      const prevBtn = modal.querySelector('[data-prev]');
      const nextBtn = modal.querySelector('[data-next]');
      const closeBtn = modal.querySelector('[data-close]');
      let active = 0;

      function render() {
        // Clear any stale width/height so the next image's natural aspect
        // ratio governs layout — otherwise the previous image's box can
        // squash the new one.
        img.removeAttribute('width');
        img.removeAttribute('height');
        img.src = urls[active];
        img.alt = 'Imagine ' + (active + 1) + ' din ' + urls.length;
        counter.textContent = (active + 1) + ' / ' + urls.length;
        prevBtn.disabled = active === 0;
        nextBtn.disabled = active === urls.length - 1;
      }
      function openModal(i) {
        active = i;
        render();
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      }
      function closeModal() {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
      function step(delta) {
        const n = urls.length;
        active = Math.max(0, Math.min(n - 1, active + delta));
        render();
      }

      prevBtn.addEventListener('click', function () { step(-1); });
      nextBtn.addEventListener('click', function () { step(1); });
      closeBtn.addEventListener('click', closeModal);

      // Click on backdrop closes (the dialog itself receives the click when its
      // ::backdrop is targeted, but the figure intercepts inside).
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      // Keyboard nav while modal is open.
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        // ESC is handled natively by <dialog>.
      });
    }

    function escapeAttr(s) {
      return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-lookalikes"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initCard(card){
      var slides = card.querySelectorAll('[data-vc-cslide]');
      var prev = card.querySelector('[data-vc-cprev]');
      var next = card.querySelector('[data-vc-cnext]');
      if (slides.length < 2) return;
      var idx = 0;
      function go(delta){
        idx = ((idx + delta) % slides.length + slides.length) % slides.length;
        slides.forEach(function(s, i){
          var on = i === idx;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('hidden');
          else s.setAttribute('hidden', '');
        });
      }
      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(-1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(1); });
    }

    function dedupItems(root){
      // Final safety net: even if Liquid dedup misses a case, kill any
      // duplicate cards by href. Runs once on init, before pagination logic.
      var seen = Object.create(null);
      var items = root.querySelectorAll('[data-vc-look-item]');
      var removed = 0;
      items.forEach(function(item){
        var a = item.querySelector('a[href]');
        if (!a) return;
        var key = (a.getAttribute('href') || '').split('?')[0].split('#')[0];
        if (!key) return;
        if (seen[key]) {
          item.parentNode.removeChild(item);
          removed++;
          return;
        }
        seen[key] = true;
      });
      if (removed) {
        root.dataset.vcLookDeduped = removed;
      }
    }

    function rebalanceVisibility(root, batch){
      var items = root.querySelectorAll('[data-vc-look-item]');
      items.forEach(function(item, i){
        if (i < batch) item.removeAttribute('hidden');
        else item.setAttribute('hidden', '');
      });
    }

    function initLook(root){
      var batch = parseInt(root.dataset.batch, 10) || 12;
      dedupItems(root);
      rebalanceVisibility(root, batch);
      root.querySelectorAll('[data-vc-card]').forEach(initCard);

      var moreBtn = root.querySelector('[data-vc-look-more]');
      var countLabel = root.querySelector('[data-vc-look-count]');
      var grid = root.querySelector('[data-vc-look-grid]');
      if (!moreBtn || !grid) return;

      function update(){
        var hidden = grid.querySelectorAll('[data-vc-look-item][hidden]');
        if (hidden.length === 0) {
          moreBtn.parentElement.style.display = 'none';
          return;
        }
        var nextChunk = Math.min(batch, hidden.length);
        if (countLabel) countLabel.textContent = '(+' + nextChunk + ')';
      }

      moreBtn.addEventListener('click', function(){
        var hidden = grid.querySelectorAll('[data-vc-look-item][hidden]');
        var n = Math.min(batch, hidden.length);
        for (var i = 0; i < n; i++) hidden[i].removeAttribute('hidden');
        update();
      });

      update();
    }

    function init(){
      document.querySelectorAll('[data-vc-look]').forEach(initLook);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-product"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // iOS 16-18 has a tight per-tab WebKit memory ceiling that crashes
    // ("A problem repeatedly occurred") on multiple 2400px-wide product
    // images. Cap hi-res to 1600px there — ~13MB decoded vs ~30MB.
    (function downgradeForOldIOS(){
      var ua = navigator.userAgent || '';
      var likelyIOS = /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      var m = /OS (\d+)[_\.]/.exec(ua);
      if (!likelyIOS || !m) return;
      var major = parseInt(m[1], 10);
      if (major < 16 || major > 18) return;
      var capWidth = function(url){
        return url ? url.replace(/([?&])width=\d+/, '$1width=1600') : url;
      };
      document.querySelectorAll('[data-hires]').forEach(function(el){
        el.setAttribute('data-hires', capWidth(el.getAttribute('data-hires')));
      });
      document.querySelectorAll('[data-vc-zoom-img]').forEach(function(img){
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', capWidth(src));
        var srcset = img.getAttribute('srcset');
        if (!srcset) return;
        var pruned = srcset.split(',').map(function(s){ return s.trim(); }).filter(function(s){
          var w = /\s+(\d+)w$/.exec(s);
          return !w || parseInt(w[1], 10) <= 1600;
        }).join(', ');
        img.setAttribute('srcset', pruned);
      });
    })();

    var preloaded = {};
    function preloadHires(url){
      if (!url || preloaded[url]) return;
      preloaded[url] = true;
      var img = new Image();
      img.src = url;
    }
    function initGallery(root){
      var slides = root.querySelectorAll('[data-vc-slide]');
      var thumbs = root.querySelectorAll('[data-vc-thumb]');
      var counter = root.querySelector('[data-vc-counter]');
      var total = slides.length;
      if (!total) return;
      var current = 0;
      function show(idx){
        idx = ((idx % total) + total) % total;
        current = idx;
        slides.forEach(function(s){
          var on = Number(s.dataset.idx) === idx;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('hidden');
          else s.setAttribute('hidden', '');
        });
        thumbs.forEach(function(t){
          t.classList.toggle('is-active', Number(t.dataset.idx) === idx);
        });
        if (counter) counter.textContent = idx + 1;
        var zoom = document.querySelector('[data-vc-zoom]');
        if (zoom) zoom.dataset.current = idx;
        // Preload hi-res for current + neighbours
        var active = slides[idx];
        if (active) preloadHires(active.dataset.hires);
        var nextEl = slides[(idx + 1) % total];
        if (nextEl) preloadHires(nextEl.dataset.hires);
        var prevEl = slides[(idx - 1 + total) % total];
        if (prevEl) preloadHires(prevEl.dataset.hires);
      }
      thumbs.forEach(function(t){
        t.addEventListener('click', function(e){
          e.preventDefault();
          show(Number(t.dataset.idx));
        });
      });
      // Main image arrows
      var prev = root.querySelector('[data-vc-main-prev]');
      var next = root.querySelector('[data-vc-main-next]');
      if (prev) prev.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        show(current - 1);
      });
      if (next) next.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        show(current + 1);
      });
      // Preload only the first hi-res. Neighbours (prev/next) are preloaded
      // lazily inside show() when the user actually navigates. Mass-preloading
      // every slide at 2400px on load decoded hundreds of MB of bitmap data
      // in WebKit and crashed iOS 16 Safari ("A problem repeatedly occurred").
      if (slides[0]) preloadHires(slides[0].dataset.hires);
    }
    function initZoom(){
      var dlg = document.querySelector('[data-vc-zoom]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      var slides = dlg.querySelectorAll('[data-vc-zoom-slide]');
      var thumbs = dlg.querySelectorAll('[data-vc-zoom-thumb]');
      var total = slides.length;
      function showZoom(idx){
        slides.forEach(function(s, i){
          var on = i === idx;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('hidden');
          else s.setAttribute('hidden', '');
          var img = s.querySelector('[data-vc-zoom-img]');
          if (img) {
            img.classList.remove('is-zoomed');
            img.style.transformOrigin = 'center center';
          }
        });
        thumbs.forEach(function(t, i){ t.classList.toggle('is-active', i === idx); });
        dlg.dataset.current = idx;
      }
      // iOS Safari ignores `body { overflow: hidden }` for top-level
      // scroll because its rubber-band gesture bypasses overflow.
      // The canonical iOS scroll-lock is `position: fixed; top: -<scrollY>px`
      // — it actually pins the document and we restore the scroll
      // position on close.
      var savedScrollY = 0;
      function lockScroll(){
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        var b = document.body;
        b.dataset.vcZoomPrevPosition = b.style.position || '';
        b.dataset.vcZoomPrevTop = b.style.top || '';
        b.dataset.vcZoomPrevWidth = b.style.width || '';
        b.dataset.vcZoomPrevOverflow = b.style.overflow || '';
        b.style.position = 'fixed';
        b.style.top = -savedScrollY + 'px';
        b.style.width = '100%';
        b.style.overflow = 'hidden';
      }
      function unlockScroll(){
        var b = document.body;
        if (!('vcZoomPrevPosition' in b.dataset)) return; // already unlocked
        b.style.position = b.dataset.vcZoomPrevPosition;
        b.style.top = b.dataset.vcZoomPrevTop;
        b.style.width = b.dataset.vcZoomPrevWidth;
        b.style.overflow = b.dataset.vcZoomPrevOverflow;
        delete b.dataset.vcZoomPrevPosition;
        delete b.dataset.vcZoomPrevTop;
        delete b.dataset.vcZoomPrevWidth;
        delete b.dataset.vcZoomPrevOverflow;
        window.scrollTo(0, savedScrollY);
      }
      function open(idx){
        showZoom(idx || 0);
        dlg.showModal();
        lockScroll();
      }
      function close(){ dlg.close(); }
      // ESC key + form-method=dialog also fire the native 'close' event;
      // unlock there so all close paths are covered.
      dlg.addEventListener('close', unlockScroll);
      document.querySelectorAll('[data-vc-zoom-open]').forEach(function(trigger){
        trigger.addEventListener('click', function(e){
          if (e.target.closest('[data-vc-main-prev], [data-vc-main-next]')) return;
          e.preventDefault();
          var current = Number(dlg.dataset.current || 0);
          open(current);
        });
        trigger.addEventListener('keydown', function(e){
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var current = Number(dlg.dataset.current || 0);
            open(current);
          }
        });
      });
      var closeBtn = dlg.querySelector('[data-vc-zoom-close]');
      if (closeBtn) closeBtn.addEventListener('click', close);
      // Close on any tap/click outside the actual image, controls, thumbs,
      // or info panel — i.e. on the dark backdrop or the row's empty area.
      dlg.addEventListener('click', function(e){
        if (e.target.closest('.vc-pdp__zoom-figure, .vc-pdp__zoom-close, .vc-pdp__zoom-nav, .vc-pdp__zoom-thumb, .vc-pdp__zoom-thumbs, .vc-pdp__zoom-info')) return;
        close();
      });
      dlg.addEventListener('keydown', function(e){
        if (e.key === 'ArrowLeft') {
          var i = Number(dlg.dataset.current || 0);
          showZoom((i - 1 + total) % total);
        }
        if (e.key === 'ArrowRight') {
          var i2 = Number(dlg.dataset.current || 0);
          showZoom((i2 + 1) % total);
        }
      });
      var prev = dlg.querySelector('[data-vc-zoom-prev]');
      var next = dlg.querySelector('[data-vc-zoom-next]');
      if (prev) prev.addEventListener('click', function(){
        var i = Number(dlg.dataset.current || 0);
        showZoom((i - 1 + total) % total);
      });
      if (next) next.addEventListener('click', function(){
        var i = Number(dlg.dataset.current || 0);
        showZoom((i + 1) % total);
      });
      // Thumb click → switch slide
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          var i = Number(t.dataset.idx || 0);
          showZoom(i);
        });
      });
      var stage = dlg.querySelector('[data-vc-zoom-stage]');
      // Reference each visible image's bounding rect via the figure (not the img),
      // because the img's hitbox includes the scaled-out (clipped) area when zoomed.
      function updateOriginFromEvent(e){
        var activeFig = dlg.querySelector('[data-vc-zoom-slide].is-active');
        if (!activeFig) return;
        var img = activeFig.querySelector('[data-vc-zoom-img]');
        if (!img || !img.classList.contains('is-zoomed')) return;
        // Use the figure's rect (visible bounds) so the cursor mapping stays
        // sane near edges even when the scaled image overflows.
        var rect = activeFig.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        img.style.transformOrigin = x + '% ' + y + '%';
      }
      function exitZoom(){
        dlg.querySelectorAll('[data-vc-zoom-img]').forEach(function(img){
          img.classList.remove('is-zoomed');
          img.style.transformOrigin = 'center center';
        });
        if (stage) stage.classList.remove('is-zoomed');
      }
      function toggleZoomAt(e){
        var activeFig = dlg.querySelector('[data-vc-zoom-slide].is-active');
        if (!activeFig) return;
        var img = activeFig.querySelector('[data-vc-zoom-img]');
        if (!img) return;
        var willZoom = !img.classList.contains('is-zoomed');
        img.classList.toggle('is-zoomed', willZoom);
        if (stage) stage.classList.toggle('is-zoomed', willZoom);
        if (willZoom) updateOriginFromEvent(e);
        else img.style.transformOrigin = 'center center';
      }
      // Click on an image (or the stage anywhere over an image) toggles zoom.
      // Listening on the stage avoids double-binding per-figure and works for
      // future-loaded slides too.
      if (stage) {
        // Desktop: click toggles zoom, mousemove tracks cursor.
        stage.addEventListener('click', function(e){
          // Ignore clicks on prev/next/close — they have their own handlers
          if (e.target.closest('[data-vc-zoom-prev],[data-vc-zoom-next],[data-vc-zoom-close]')) return;
          // Only count clicks landing on an image
          if (!e.target.closest('[data-vc-zoom-img]')) return;
          toggleZoomAt(e);
        });
        stage.addEventListener('mousemove', updateOriginFromEvent);
        // Exit zoom only when the cursor leaves the stage entirely (not when
        // it crosses a nav arrow — those sit absolute on top of the stage).
        stage.addEventListener('mouseleave', exitZoom);

        // Mobile: double-tap to toggle zoom, single tap is reserved for
        // toggling overlay (left as click handler above), swipe to navigate.
        var lastTap = 0;
        var lastTapX = 0, lastTapY = 0;
        stage.addEventListener('touchend', function(e){
          if (e.touches.length > 0) return;
          if (!e.target.closest('[data-vc-zoom-img]')) return;
          var t = e.changedTouches[0];
          var now = Date.now();
          var dx = Math.abs(t.clientX - lastTapX);
          var dy = Math.abs(t.clientY - lastTapY);
          if (now - lastTap < 300 && dx < 30 && dy < 30) {
            // Double tap → toggle zoom centered on tap point
            e.preventDefault();
            toggleZoomAt({ clientX: t.clientX, clientY: t.clientY });
            lastTap = 0;
          } else {
            lastTap = now;
            lastTapX = t.clientX;
            lastTapY = t.clientY;
          }
        });

        // Swipe to switch slides — disabled while zoomed (the user is panning).
        var swipeX = null, swipeY = null, swipeMoved = false;
        stage.addEventListener('touchstart', function(e){
          if (e.touches.length !== 1) { swipeX = null; return; }
          swipeX = e.touches[0].clientX;
          swipeY = e.touches[0].clientY;
          swipeMoved = false;
        }, { passive: true });
        stage.addEventListener('touchmove', function(e){
          if (swipeX === null) return;
          var t = e.touches[0];
          if (Math.abs(t.clientX - swipeX) > 10 || Math.abs(t.clientY - swipeY) > 10) {
            swipeMoved = true;
          }
          // While zoomed, finger drag pans the image instead of swiping.
          var anyZoomed = stage.classList.contains('is-zoomed');
          if (anyZoomed) {
            updateOriginFromEvent({ clientX: t.clientX, clientY: t.clientY });
            e.preventDefault();
          }
        }, { passive: false });
        stage.addEventListener('touchend', function(e){
          if (swipeX === null || !swipeMoved) { swipeX = null; return; }
          if (stage.classList.contains('is-zoomed')) { swipeX = null; return; }
          var t = e.changedTouches[0];
          var dx = t.clientX - swipeX;
          var dy = t.clientY - swipeY;
          swipeX = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            var i = Number(dlg.dataset.current || 0);
            if (dx < 0) showZoom((i + 1) % total);
            else        showZoom((i - 1 + total) % total);
          }
        });
      }
    }
    function init(){
      document.querySelectorAll('[data-vc-gallery]').forEach(initGallery);
      initZoom();
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
    else { init(); }
  })();

  } catch(e) { console.error(e); }
})();
})();
